import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { addAction } from '@/redux/store/information';
import request from '@/server/request';
import config from '@/server/config';
import UploadImg from '@/pages/components/uploadImg';
import ActionSheet from '@/pages/components/common/ui/actionsheet';
import alert from '@/pages/components/common/alert';

import '@/pages/containers/auth/scss/form.scss';
import '../scss/index.scss';
class StoreInformation extends React.Component < any, any > {
    constructor(props: any) {
        super(props);
        this.state = {
            id: this.props.location.state ? this.props.location.state.id : '', // 企业id
        }
    }

    public componentDidMount() {

        if (this.props.history.action === 'PUSH') {
            this.initData();
        }
        this.initName();

    }

    public render() {
        return (
            <div className="gray-bg">
				<ActionSheet project="store" />
				<div className="default-form">
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>店铺链接</label>
						<button
							className="input-select text-right" 
							data-value={this.props.shop_domain }
							onClick={() => this._checkLogin(() => { (this.props as any).history.push('/store/editLink')  }) }
							>
							{ this.props.shop_domain ? (this.props.shop_domain + '.cn.ibuychem.com') : '请输入店铺链接' }
						</button>
					</div>
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>商铺名称</label>
						{/*<input type="text" placeholder="请输入邮箱" className="text-right"  disabled={true} />*/}
						<input
							type="text" 
							placeholder="请输入商铺名称" 
							className="text-right" 
							value={(this.props as any).shop_name || '' }
							onChange={ (e:any) => this.changeInfoState('shop_name', e.target.value) }/>
					</div>
					{/*<div className="form-input-warrper">
						<label className="label">商铺介绍</label>
						<button
							className="input-select text-right text-overflow" 
							data-value={(this.props as any).presentation || ''}
							onClick={() => this._checkLogin(() => { (this.props as any).history.push('/store/editIntroduce')  }) }
							>
							{ this.props.presentation || '请输入商铺介绍' }
						</button>
					</div>*/}
					<div className="form-upload-warrper">
						<label className="label"><span className="red">*</span>商铺LOGO <span className="label-tips">(图片比例 1:1)</span></label>
						<div className="form-upload">
							<UploadImg sucess={(data: any) => this.changeInfoState('pc_logo', data)}  id={(this.props as any).pc_logo} project="store"/>
						</div>
					</div>
					{/*<div className="form-upload-warrper">
						<label className="label"><span className="red">*</span>移动端商铺LOGO <span className="label-tips">(图片比例 2:1)</span></label>
						<div className="form-upload">
							<UploadImg  sucess={(data: any) => this.changeInfoState('mobile_logo', data)}  id={(this.props as any).mobile_logo} />
						</div>
					</div>*/}
					<div className="form-input-warrper">
						<label className="label">原材料供应商</label>
						<button
							className="input-select text-right text-overflow" 
							data-value={this.state.supplierName}
							onClick={() => this._checkLogin(() => { (this.props as any).history.push('/store/EditSupplier')  }) }
							>
							{ this.state.supplierName || '请输入原材料供应商' }
						</button>
					</div>
					<div className="form-input-warrper">
						<label className="label">优选客户</label>
						<button
							className="input-select text-right text-overflow" 
							data-value={this.state.customerName}
							onClick={() => this._checkLogin(() => { (this.props as any).history.push('/store/editCustomer')  }) }
							>
							{ this.state.customerName || '请输入优选客户' }
						</button>
					</div>
				</div>

				<div className="form-btn-warrrper"><button className="form-btn" onClick={() => this.submitForm()}>保存设置</button></div>
			</div>
        )
    }

    private initName() {
        if (this.props.supplier && this.props.supplier.length > 0) {

            const result = (this.props as any).supplier.map((v: any) => {
                return v.name
            })

            this.setState({
                supplierName: result.join(),
            })
        }

        if (this.props.customers && this.props.customers.length > 0) {
            const result2 = (this.props as any).customers.map((v: any) => {
                return v.name
            })
            this.setState({
                customerName: result2.join()
            })
        }
    }
    // 初始化
    private async initData() {
        const r = await request({
            method: "post",
            url: `${config.MALLAPI}api/shop/default`,
            data: {
                companyId: this.state.id,
            }
        });

        if (r.error_code === 0) {
            (this.props as any).addAction({
                shop_name: r.data.shop_name,
                shop_domain: r.data.domain,
                presentation: r.data.presentation,
                supplier: r.data.material_supplier,
                customers: r.data.preferred_customers,
                pc_logo: r.data.pc_logo,
                mobile_logo: r.data.pc_logo,
            })

            this.initName();
        }
    }

    private changeInfoState(k: string, v: any) {
        (this.props as any).addAction({
            [k]: v
        })
    }

    private async _checkLogin(callback ? : Function) {
        const r = await request({
            method: "get",
            url: `${config.WAPAPI}safety/account/get`,
            data: {
                queryType: 1,
            }
        });

        if (r.code === 100) {
            this.setState({
                isLogin: false,
            });
        } else if (r.code === 1) {
            this.setState({
                isLogin: true,
                userInfo: r.obj,
            }, () => {
                callback ? callback() : "";
            });
        }
    }

    private async submitForm() {
        if (!(this.props as any).shop_domain) {
            alert.open({
                promptText: '店铺链接不能为空！'
            })
            return;
        }
        let shop_name = (this.props as any).shop_name.replace(/\s+/img, '');
        if (!shop_name) {
            alert.open({
                promptText: '商铺名称不能为空！'
            })
            return;
        }
        if (!(this.props as any).pc_logo) {
            alert.open({
                promptText: '商铺LOGO不能为空！'
            })
            return;
        }
        // if(!(this.props as any).mobile_logo) {
        // 	alert.open({
        // 		promptText: '移动端商铺LOGO不能为空！'
        // 	})
        // 	return ;
        // }



        const r = await request({
            method: "post",
            url: `${config.MALLAPI}api/shop/default/init-edit`,
            data: {
                companyId: this.state.id,
                shop_domain: (this.props as any).shop_domain,
                // shop_domain: 'grace',
                shop_name: (this.props as any).shop_name,
                presentation: (this.props as any).presentation,
                pc_logo: (this.props as any).pc_logo,
                mobile_logo: (this.props as any).pc_logo,
                supplier: this.props.supplier && this.props.supplier.length > 0 ? JSON.stringify((this.props as any).supplier) : [],
                customers: this.props.customers && this.props.customers.length > 0 ? JSON.stringify((this.props as any).customers) : [],
            }
        });

        if (r.error_code === 0) {
            alert.open({
                promptText: '修改成功！'
            });
            (window as any).integral.sign({
                env: config.ENV !== 'production' ? 'dev' : 'pro',
                code: '00_04_00_001',
                entityId: this.state.id,
                entityType: 'wshop'
            });
            setTimeout(() => {
                (this.props as any).history.push('/');
            }, 1500);
        } else {
            alert.open({
                promptText: r.msg
            });
        }
    }
}

const mapStateToProps = (state: any) => {
    return {
        ...state.storeInformationReducer
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return bindActionCreators({ addAction }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreInformation);